export const CHART_COLORS = [
  '#8884d8',
  '#82ca9d',
  '#ffc658',
  '#ff8042',
  '#a4de6c',
  '#d0ed57',
  '#8dd1e1',
  '#d88884',
  '#84d8c2',
  '#c284d8',
  '#d8a484',
  '#84c2d8',
  '#d884b0',
  '#b0d884',
  '#d8c284',
  '#84d8a4',
  '#a484d8',
  '#84d8d0',
  '#d0a484',
  '#a4d884',
];

export function getChartColorByIndex(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length];
}
